import React from 'react';
import { Helmet } from 'react-helmet';
import '../css/TermsConditions.css'; 

const TermsConditions = () => {
  return (
    <div>
      <Helmet>
        <title>Urbania on Rent in Pune | Terms & Conditions</title>
        <meta 
          name="description" 
          content="Terms & Conditions for Urbania on Rent in Pune by Urbania on Rent in Pune" 
        />
      </Helmet>





<div
      className="breadcumb-wrapper"
      
      data-overlay="black"
      data-opacity="3"
    >
      <div className="container">
        <div className="breadcumb-content text-center">
          <h1 className="breadcumb-title">Terms & Conditions</h1>
        </div>
      </div>
    </div>






   

      <section className="terms-section">
        <div className="container">
          <div className="row g-0">
            <div className="col-md-7">
              <div className="terms-content">

                <p>
                  <b className="highlight">1. Booking Confirmation:</b> 
                  All Urbania bookings in Pune are subject to vehicle availability. 
                  Confirmation will be provided after advance payment or approval from our team.
                </p>

                <p>
                  <b className="highlight">2. Vehicle Usage:</b> 
                  The Force Urbania vehicle is provided only for passenger transport. 
                  Commercial goods or illegal items are strictly prohibited.
                </p>

                <p>
                  <b className="highlight">3. Payment Policy:</b> 
                  Payments can be made via online transfer, UPI, or cash. 
                  Advance payment is mandatory for outstation, wedding, or corporate bookings.
                </p>

                <p>
                  <b className="highlight">4. Cancellation & Rescheduling:</b> 
                  Cancellations must be made in advance. Charges may apply based on 
                  the time of cancellation and booking type.
                </p>

                <p>
                  <b className="highlight">5. Passenger Responsibility:</b> 
                  Customers must provide correct pickup locations in Pune or nearby areas. 
                  Delays caused by incorrect information may incur waiting charges.
                </p>

                <p>
                  <b className="highlight">6. Seating & Baggage:</b> 
                  Passenger count must not exceed the Urbania seating capacity. 
                  Limited luggage space is available; excess baggage may attract additional charges.
                </p>

                <p>
                  <b className="highlight">7. Driver Duty Hours:</b> 
                  Driver working hours are limited as per transport rules. 
                  Extended usage may require driver allowance or replacement.
                </p>

                <p>
                  <b className="highlight">8. Safety Guidelines:</b> 
                  Wearing seatbelts is mandatory. Any damage caused to the vehicle 
                  by passengers will be chargeable.
                </p>

                <p>
                  <b className="highlight">9. Refusal of Service:</b> 
                  We reserve the right to cancel or refuse service in cases of 
                  misbehavior, intoxication, or unsafe conditions.
                </p>

                <p>
                  <b className="highlight">10. Jurisdiction:</b> 
                  All disputes shall be governed under Pune, Maharashtra jurisdiction.
                </p>

                <h3>Rental Policy</h3>
                <p>
                  <b className="highlight">Local & Outstation Use:</b> 
                  Urbania rentals are available for Pune local travel, outstation trips, 
                  weddings, corporate events, and group tours.
                </p>

                <p>
                  <b className="highlight">Toll, Parking & Taxes:</b> 
                  Toll charges, parking fees, and state taxes are payable by the customer 
                  unless specified in the booking.
                </p>

                <h3>Refund Policy</h3>
                <p>
                  <b className="highlight">Eligible Refunds:</b> 
                  Refunds depend on cancellation timing and booking category.
                </p>

                <p>
                  <b className="highlight">Refund Timeline:</b> 
                  Approved refunds will be processed within 5–7 working days 
                  to the original payment method.
                </p>

                <p>
                  <b className="highlight">No-Show Policy:</b> 
                  No refunds will be provided for no-shows or last-minute cancellations.
                </p>

              </div>
            </div>
          </div>

          <div className="contact-info">
            <h2>Contact Us</h2>
            <p>For Urbania booking support in Pune, contact us:</p>
            <ul>
              <li><b>Phone:</b> <a href="tel:+91 9209423113">+91  9209423113</a></li>
              <li><b>Email:</b> <a href="mailto: booking@urbaniaonrentpune.in"> booking@urbaniaonrentpune.in</a></li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsConditions;
